import {getBottomSpace, isIphoneX} from 'react-native-iphone-screen-helper';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {Platform} from 'react-native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Header = styled.View`
  padding: 0 24px;
  padding-top: ${!getBottomSpace() ? RFValue(20) : 0}px;
  padding-bottom: ${!getBottomSpace() ? RFValue(14) : 0}px;
  z-index: 2;
  background-color: ${({theme}) => theme.colors.primary};
  flex-direction: row;
`;

export const Content = styled.View`

  flex: 1;
`;

export const HeaderButton = styled.TouchableOpacity``;

export const HeaderIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(24)}px;
`;
